export type IdentityDocument = 'licence' | 'medicare' | 'passport'
export type IdentityPiece = 'address'

export interface DocumentProps {
  onSuccess?: () => any
  onFailure?: () => any
}

export const IdentityDocuments = {
  LICENCE: 'licence' as const,
  MEDICARE: 'medicare' as const,
  PASSPORT: 'passport' as const,
} as const

export const toIdentityDocument = (str?: string | string[]): IdentityDocument | null => {
  if (Array.isArray(str)) {
    str = str[0]
  }
  if (typeof str === 'undefined') {
    return null
  }
  switch (str) {
    case 'medicare':
    case 'passport':
    case 'licence':
      return str
    default:
      return null
  }
}
